<template>
<div class="chapter">
<div class="inner_page">
<h1 class="otherbooks" id="frw">Foreword</h1>
<h2 class="sec">SIXTY-FIVE YEARS, AND COUNTING… 2061: The View from 1996</h2>
<p class="nonindent">Once again, the time has come to survey an enterprise begun more than thirty years ago, before a whole series of scientific discoveries and technological revolutions changed our world almost beyond recognition. When I started writing <em>2001: A Space Odyssey</em> (on a typewriter—have you seen one lately?), Neil Armstrong’s “One small step” was still five years in the future, and the moons of Jupiter were dimensionless points of light, their landscapes as unknown as America to the pre-Columbian mapmakers. Yet now, as I write these words, the Galileo space probe is showing us details only a few meters across. Even more amazing, at any moment I can view them here in my own office, by pressing a few keys. (When, as frequently happens, I press the wrong ones, I hear a familiar voice saying “I’m sorry, Dave—I can’t do that.”)</p>
<p class="indent">So there is no avoiding the fact that some elements of a Space Trilogy conceived in 1964, 1982, and even 1987 may now have a quaint Jane Austenish charm. Yet no revision could or should attempt to eliminate them—any more than one should try to “update” H. G. Wells’ <em>The First Men in the Moon</em>.</p>
<p class="indent">What I have done, therefore, is to leave the existing text, including the various Author’s Notes and Acknowledgments, completely unaltered—but have added a 1996 Postscript commenting on the truly astonishing changes that have taken place in technology—and politics—since Stanley Kubrick and I lunched together in Trader Vicks’, on April 22, 1964.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795324857_epub_frw_r1.vue?1887f4ae